import Vue from 'vue';

export default {
    install(V: typeof Vue, options: any) {
        V.prototype.$notifier = {
            showError: (msg: string) => {
                options.store.commit('notificationDialog/showMessage', { type: 'error', title: 'Error', msg });
            },
            showSuccess: (msg: string) => {
                options.store.commit('notificationDialog/showMessage', { type: 'success', title: 'Success', msg });
            },
            showWarning: (msg: string, onYesClicked?: Function) => {
                options.store.commit('notificationDialog/showMessage', {
                    type: 'warning', title: 'Warning', msg, onYesClicked,
                });
            },
            showInfo: (msg: string, onYesClicked?: Function) => {
                options.store.commit('notificationDialog/showMessage', {
                    type: 'info', title: 'Info', msg, onYesClicked,
                });
            },
        };
    },
};
